import {Injectable} from "@angular/core";
import {Headers, Http} from "@angular/http";
import "rxjs/add/operator/toPromise";
import 'rxjs/add/operator/map';
import {LoaderService} from "./loader.service";
import {isNullOrUndefined} from "util";
import {Router} from "@angular/router";
import {environment} from '../../environments/environment';

enum HostType {
  FrontRest = 0,
  FilesRest = 1
}

@Injectable()
export class HttpService {

  REST_ADDR = environment.restAddr;
  FILES_ADDR = environment.fileRestAddr;

  static createAuthorizationHeaderByUser(headers: Headers, user, isWatching: boolean) {
    HttpService.createAuthorizationHeader(headers, user.login, user.password, isWatching);
  }

  private static getObject(o: any) {
    try {
      return o.json();
    } catch (err) {
      return o;
    }
  }

  static b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  static b64EncodeUnicode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode(Number('0x' + p1));
      }));
  }

  static createAuthorizationHeader(headers: Headers, username: string, password: string,
                                   isWatching: boolean) {


    headers.append('Authorization', localStorage.getItem('token'));
    headers.append('withCredentials', 'true');
    headers.append('X-Requested-With', 'XMLHttpRequest');
    headers.append('organizationAlias', localStorage.getItem("organizationAlias"));
    const userToWatchFrom = JSON.parse(sessionStorage.getItem('userToWatchFrom'));
    if (isWatching && userToWatchFrom != null) {
      headers.append('userToWatchFrom', userToWatchFrom.userId);
    }
  }

  constructor(private http: Http,
              private router: Router,
              private spinnerService: LoaderService) {
  }

  getRawData(url: string) {
    url = encodeURI(url);
    return this.http.get(this.REST_ADDR + url)
      .map(res => {
        return res.json();
      });
  }

  private async getDataFrom(url: string, host: HostType, blockId?: string): Promise<any> {
    url = encodeURI(url);
    this.spinnerService.showSpinner(blockId);

    const response = await this.http.get(this.getHostAddr(host, url)).toPromise()
      .then(result => {
        this.spinnerService.hideSpinner(blockId);
        return result;
      }, err => {
        this.spinnerService.hideSpinner(blockId);
        throw err;
      });

    this.spinnerService.hideSpinner(blockId);
    return HttpService.getObject(response);
  }

  async getFilesData(url: string, blockId?: string): Promise<any> {
    return this.getDataFrom(url, HostType.FilesRest, blockId);
  }

  async getData(url: string, blockId?: string): Promise<any> {
    return this.getDataFrom(url, HostType.FrontRest, blockId);
  }

  async getDataWithLocalAuth(url: string, blockId?: string, showSpinner?: boolean,
                             isWatching: boolean = true): Promise<any> {
    return this.getDataWithAuth(url, HostType.FrontRest, blockId, showSpinner, isWatching);
  }

  async getFilesDataWithAuth(url: string, blockId?: string, showSpinner?: boolean,
                             isWatching: boolean = true): Promise<any> {
    return this.getDataWithAuth(url, HostType.FilesRest, blockId, showSpinner, isWatching);
  }

  private getHostAddr(host: HostType, url: string) {
    if(host == HostType.FrontRest) {
      return this.REST_ADDR + url;
    }
    if(host == HostType.FilesRest) {
      return this.FILES_ADDR + url;
    }

  }

  async postData(url: string, body: any, blockId?: string): Promise<any> {
    return this.postDataTo(url, body, HostType.FrontRest);
  }

  async postFilesData(url: string, body: any, blockId?: string): Promise<any> {
    return this.postDataTo(url, body, HostType.FilesRest);
  }

  private async postDataTo(url: string, body: any, host: HostType, blockId?: string): Promise<any> {
    url = encodeURI(url);
    this.spinnerService.showSpinner(blockId);

    const response = await this.http.post(this.getHostAddr(host, url), body).toPromise()
      .then(result => {
        this.spinnerService.hideSpinner(blockId);
        return result;
      }, err => {
        this.spinnerService.hideSpinner(blockId);
        throw err;
      });

    return HttpService.getObject(response);
  }

  // async getDataWithUser(url: string, user): Promise<any> {
  //
  //   const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  //
  //   const headers = new Headers();
  //   this.createAuthorizationHeaderByUser(headers, user);
  //   //this.loaderService.displayLoader(true); // enable spinner
  //   console.log('Loading in get');
  //
  //   const response = await this.http.get((this.REST_ADDR + url), {
  //     headers: headers
  //   }).toPromise();
  //   //this.loaderService.displayLoader(false); // disable spinner
  //   console.log(response.json());
  //
  //   console.log('Loaded in get');
  //   return response.json();
  // }

  async getRawDataWithLocalAuth(url: string, blockId?: string,
                                isWatching: boolean = true): Promise<any> {
    return this.getRawDataWithLocalAuthFrom(url, HostType.FrontRest, blockId, isWatching);
  }


  /**
   *
   * @param {string} url - Адрес запроса
   * @param {string} blockId - Блок на который надо повесить спинер
   * @param {boolean} [isWatching=true] - Если true - делать запрос от лица пользователя за которым
   * "подсматриваем", иначе от лица текущего. (По умолчанию установлен true - т.е. если в
   * localStorage указан userToWatchFrom то все запросы по умолчанию будут делаться от его лица)
   */
  private async getRawDataWithLocalAuthFrom(url: string, host: HostType, blockId?: string,
                                    isWatching: boolean = true): Promise<any> {
    url = encodeURI(url);
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    const headers = new Headers();
    HttpService.createAuthorizationHeaderByUser(headers, currentUser, isWatching);

    const response = await this.http.get(this.getHostAddr(host, url), {
      headers: headers
    }).toPromise().then(result => {
      this.spinnerService.hideSpinner(blockId);
      return result;
    }, err => {
      this.spinnerService.hideSpinner(blockId);
      if (err.status === 401) {
        this.router.navigate([localStorage.getItem("organizationAlias") + "/login"]);
      }
      if (err.status === 403) {
        this.router.navigate([localStorage.getItem("organizationAlias") + "/login"]);
      }
      if (err.status === 500) {
        this.router.navigate(["error"]);
      }
      throw err;
    });

    return response;
  }

  /**
   *
   * @param {string} url - Адрес запроса
   * @param host {HostType} - Тип хоста (рест или файл рест)
   * @param {string} blockId - Блок на который надо повесить спинер
   * @param {boolean} showSpinner - Показывать спинер при запросе или нет
   * @param {boolean} [isWatching=true] - Если true - делать запрос от лица пользователя за которым
   * "подсматриваем", иначе от лица текущего. (По умолчанию установлен true - т.е. если в
   * localStorage указан userToWatchFrom то все запросы по умолчанию будут делаться от его лица)
   */
  private async getDataWithAuth(url: string, host: HostType, blockId?: string, showSpinner?: boolean,
                             isWatching: boolean = true): Promise<any> {

    showSpinner = isNullOrUndefined(showSpinner) ? true : showSpinner;

    if (showSpinner) {
      this.spinnerService.showSpinner(blockId);
    }

    return this.getRawDataWithLocalAuthFrom(url, host, blockId, isWatching).then(value => {
      // console.debug(HttpService.getObject(value));
      if (showSpinner) {
        this.spinnerService.hideSpinner(blockId);
      }
      return HttpService.getObject(value);
    });
  }

  /**
   *
   * @param {string} url - Адрес запроса
   * @param body
   * @param {string} blockId - Блок на который надо повесить спинер
   * @param {boolean} [isWatching=true]- Если true - делать запрос от лица пользователя за которым
   * "подсматриваем", иначе от лица текущего. (По умолчанию установлен true - т.е. если в
   * localStorage указан userToWatchFrom то все запросы по умолчанию будут делаться от его лица)
   * @param showSpinner - Показывать спинер при запросе или нет
   */
  async postDataWithAuth(url: string, body, blockId?: string,
                         isWatching: boolean = true, showSpinner: boolean = true): Promise<any> {
    return this.postDataWithAuthTo(url, body, HostType.FrontRest, blockId,
      isWatching, showSpinner);
  }

  async postFilesDataWithAuth(url: string, body, blockId?: string,
                              isWatching: boolean = true, showSpinner: boolean = true): Promise<any> {
    return this.postDataWithAuthTo(url, body, HostType.FilesRest, blockId,
      isWatching, showSpinner);
  }

  private async postDataWithAuthTo(url: string, data, host: HostType, blockId?: string,
                                   isWatching: boolean = true, showSpinner: boolean = true) {
    url = encodeURI(url);
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (showSpinner) {
      this.spinnerService.showSpinner(blockId);
    }

    const headers = new Headers();
    HttpService.createAuthorizationHeaderByUser(headers, currentUser, isWatching);

    const response = await this.http.post(this.getHostAddr(host, url), data, {
      headers: headers
    }).toPromise().then(result => {
        if (showSpinner) {
        this.spinnerService.hideSpinner(blockId);
      }
      return result;
    }, err => {
          if (showSpinner) {
        this.spinnerService.hideSpinner(blockId);
      }
      throw err;
    });

    return HttpService.getObject(response);
  }


}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/http.service.ts